module.exports = __webpack_public_path__ + "static/media/4.fc478fe7.jpg";